import { getApolloContext } from '@apollo/client'
import React, { useMemo } from 'react'

export const SimpleApolloProvider = ({ client, children }) => {
  const ApolloContext = getApolloContext()

  // Use useMemo to prevent context from updating during
  // rerenders with the same client. Generally the client
  // will remain the same throughout the lifetime of the
  // application, but when {client} is used, (or as official
  // implementation context = Object.assign({}, context, { client }))
  // each rerender will create a new object, causing *all*
  // useQuery/useMutation hooks to rerender due to changed context
  // value.
  const context = useMemo(
    () => ({
      client
    }),
    [client]
  )

  return <ApolloContext.Provider value={context}>{children}</ApolloContext.Provider>
}
